import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import StarRating from '../../../molecules/shared/starRating/StarRating';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import SystemGuideCard from '../../../molecules/category/systemGuideCard/SystemGuideCard';
import InfoPopup from '../../../molecules/shared/infoPopup/InfoPopup';
import { Row } from '../../../atoms/row/Row';
import { Open } from '../../../../../static/icons/open';

export const SystemInfoHeader = ({
  section,
  isPaid,
  openModalForm,
  t,
  trackOutboundLink,
  className,
  rootClassName,
}) => {
  const {
    imgUrl,
    title,
    subTitle,
    rating,
    websiteButtonHref,
    websiteButtonText,
    followLink,
    extraBtnText,
    extraBtnLink,
    card,
    systemId,
    category,
  } = section.componentData;

  return (
    <div
      className={`flex w-full flex-col flex-1 px-8 lg:mx-auto my-10 md:my-5 max-w-7xl ${rootClassName}`}
    >
      <div
        className={`flex flex-col md:flex-row flex-1 justify-between ${className}`}
      >
        <div className="flex flex-col lg:flex-row h-auto min-h-60 w-fit items-start lg:items-center gap-6 md:gap-2 lg:gap-14">
          <img
            className="w-[200px] h-[100px]"
            src={imgUrl}
            alt={`${title} logo`}
            width="200"
            height="100"
          />
          <Stack className="h-full justify-center">
            <Typography textAlign="left" as="h1" fontVariant="h4">
              {title}
            </Typography>
            <Typography textAlign="left" as="h2" fontVariant="h8">
              {subTitle}
            </Typography>
            <div className="flex flex-col sm:flex-row justify-center items-start sm:items-center gap-6">
              <div className="flex flex-row gap-3">
                <StarRating
                  rating={rating}
                  fillColor="#FEC84B"
                  width={20}
                  height={20}
                />
                <InfoPopup
                  displayDirection="right"
                  description={t('sp.ratingPopover')}
                />
              </div>
              <LinkButton
                variant="transparent"
                textTransform="uppercase"
                size="lg"
                onClick={openModalForm}
                className="text-clamp-xs border border-customGray-300 text-center min-w-fit"
                label={t('sp.writeReview')}
              />
            </div>
          </Stack>
        </div>
        <Stack className="min-w-60 justify-center items-center gap-2 mt-10 md:mt-0">
          {isPaid && (websiteButtonHref || extraBtnLink) ? (
            <>
              {websiteButtonHref && (
                <LinkButton
                  variant="primary-filled"
                  textTransform="uppercase"
                  external
                  href={websiteButtonHref}
                  trackingFn={() => {
                    trackOutboundLink(
                      {},
                      websiteButtonHref,
                      category,
                      'system-page-top',
                      systemId,
                      {
                        page_type: 'System page',
                        system_name: title,
                        result_position: 'top',
                      }
                    );
                  }}
                  size="lg"
                  className="text-clamp-sm leading-5 border gap-1 border-primary-700 min-w-60 max-md:w-full justify-center"
                >
                  {websiteButtonText || t('sp.visitWebsite')} <Open size={20} />
                </LinkButton>
              )}
              {extraBtnLink && extraBtnText ? (
                <LinkButton
                  variant={
                    websiteButtonHref ? 'secondary-filled' : 'primary-filled'
                  }
                  textTransform="uppercase"
                  size="lg"
                  external
                  followLink={followLink}
                  href={extraBtnLink}
                  trackingFn={() => {
                    trackOutboundLink(
                      {},
                      extraBtnLink,
                      category,
                      'system-page-top',
                      systemId,
                      {
                        page_type: 'System page',
                        system_name: title,
                        result_position: 'top',
                      }
                    );
                  }}
                  className="text-clamp-sm leading-5 border gap-1 border-customGray-300 min-w-60 max-md:w-full justify-center mt-2"
                >
                  {extraBtnText}
                  <Open size={20} />
                </LinkButton>
              ) : null}
            </>
          ) : (
            card && (
              <SystemGuideCard
                title={card.title}
                description={card.description}
                href={card.url}
                icon={card.icon}
                handleClick={card.handleClick}
              />
            )
          )}
        </Stack>
      </div>
    </div>
  );
};
